<form
    class="flex flex-col px-20 py-10"
    [formGroup]="form">
    <button
        type="button"
        class="mb-5 self-start"
        mat-flat-button
        color="primary"
        (click)="addMilestone(null)">
        Add new milestone
    </button>
    <table
        class="mat-elevation-z8 mb-5"
        mat-table
        [dataSource]="dataSource"
        formArrayName="milestones">
        <ng-container matColumnDef="rarity">
            <th
                mat-header-cell
                *matHeaderCellDef>
                Rarity
            </th>
            <td
                class="!py-5"
                mat-cell
                *matCellDef="let element; let index = index"
                [formGroupName]="index">
                <mat-form-field>
                    <mat-select formControlName="rarity">
                        @for (item of SpinWheelMilestoneRarity | appEnumKeyValue; track $index) {
                            <mat-option [value]="item.value">{{ item.key }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </td>
        </ng-container>
        <ng-container matColumnDef="rewardType">
            <th
                mat-header-cell
                *matHeaderCellDef>
                Reward type
            </th>
            <td
                class="!py-5"
                mat-cell
                *matCellDef="let element; let index = index"
                [formGroupName]="index">
                <mat-form-field>
                    <mat-select formControlName="rewardType">
                        @for (item of RewardType | appEnumKeyValue; track $index) {
                            <mat-option [value]="item.value">{{ item.key }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </td>
        </ng-container>
        <ng-container matColumnDef="reward">
            <th
                mat-header-cell
                *matHeaderCellDef>
                Reward
            </th>
            <td
                class="!py-5"
                mat-cell
                *matCellDef="let element; let index = index"
                [formGroupName]="index">
                @if (form.controls.milestones.value[index].rewardType === RewardType.Currency) {
                    <mat-form-field>
                        <input
                            matInput
                            type="number"
                            noScroll
                            formControlName="reward" />
                    </mat-form-field>
                }
            </td>
        </ng-container>
        <ng-container matColumnDef="expReward">
            <th
                mat-header-cell
                *matHeaderCellDef>
                Exp reward
            </th>
            <td
                class="!py-5"
                mat-cell
                *matCellDef="let element; let index = index"
                [formGroupName]="index">
                @if (form.controls.milestones.value[index].rewardType === RewardType.Currency) {
                    <mat-form-field>
                        <input
                            matInput
                            type="number"
                            noScroll
                            formControlName="expReward" />
                    </mat-form-field>
                }
            </td>
        </ng-container>
        <ng-container matColumnDef="dropChance">
            <th
                mat-header-cell
                *matHeaderCellDef>
                Drop chance
            </th>
            <td
                class="!py-5"
                mat-cell
                *matCellDef="let element; let index = index"
                [formGroupName]="index">
                <mat-form-field>
                    <input
                        matInput
                        type="number"
                        noScroll
                        formControlName="dropChance" />
                </mat-form-field>
            </td>
        </ng-container>
        <ng-container matColumnDef="order">
            <th
                mat-header-cell
                *matHeaderCellDef>
                Order
            </th>
            <td
                class="!py-5"
                mat-cell
                *matCellDef="let element; let index = index"
                [formGroupName]="index">
                <mat-form-field>
                    <input
                        matInput
                        type="number"
                        noScroll
                        formControlName="order" />
                </mat-form-field>
            </td>
        </ng-container>
        <ng-container matColumnDef="actions">
            <th
                mat-header-cell
                *matHeaderCellDef></th>
            <td
                mat-cell
                *matCellDef="let element; let index = index">
                <button
                    mat-icon-button
                    color="warn"
                    (click)="removeMilestone(index)">
                    <mat-icon>delete</mat-icon>
                </button>
            </td>
        </ng-container>
        <tr
            mat-header-row
            *matHeaderRowDef="displayedColumns()"></tr>
        <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns()"></tr>
    </table>
    <button
        type="button"
        class="mb-5 self-start"
        mat-flat-button
        color="primary"
        (click)="updateMilestones()">
        Save changes
    </button>
</form>
